import { ActionType, createAction } from 'typesafe-actions'

import { Company, KeyValue } from './types'

export const CompanyDetailActions = {
  loadCompany: createAction('COMPANY_DETAIL/load-company')<{
    companyIdentifier: string
    includeOfficialDocuments?: boolean
    formerName?: string
  }>(),
  loadCompanyByState: createAction('COMPANY_DETAIL/load-company-by-state')<{
    companyIdentifier: string
    formerName?: string
  }>(),
  loadCompanyWithMoreDocuments: createAction('COMPANY_DETAIL/load-company-more-documents')<{
    companyIdentifier: string
    formerName?: string
  }>(),
  loadCompanyWithSelectedDocument: createAction('COMPANY_DETAIL/load-company-with-selected-document')<{
    companyIdentifier: string
    documentCode: string | undefined
    formerName?: string
  }>(),
  setLoadedCompany: createAction('COMPANY_DETAIL/set-company')<{
    companyId: string
    company: Company
    officialDocumentRequested: boolean
    selectedDocumentCode: string | undefined
    fetchedDocuments: number
    areDocumentsInPriceList: boolean
    documentsLimitReached: boolean
    documentsKeyValues: KeyValue[]
  }>()
}

export type CompanyDetailActions = ActionType<typeof CompanyDetailActions>
